import { NewsletterPayload } from 'models/endpoints-payload'
import { NewsletterResponse } from 'models/endpoints-respone'

import { promiseWrapper } from 'utils/promise'
import { newsletterTokenList } from '../config/newsletter-consent'

declare const USER_BASE_URL_WT: string
const NEWSLETTER_SUBSCRIBE_ENDPOINT = '/api/public/subscribe-to-newsletter'

export const signUpForNewsletter = (payload: NewsletterPayload): Promise<NewsletterResponse> => {
  payload['list'] = newsletterTokenList.default
  return promiseWrapper<NewsletterResponse, NewsletterPayload>(
    `${USER_BASE_URL_WT}${NEWSLETTER_SUBSCRIBE_ENDPOINT}`,
    'POST',
    payload,
  )
}

export const signUpForCardTests = (
  payload: NewsletterPayload,
  opinionsConsent: boolean,
): Promise<NewsletterResponse> => {
  payload['list'] = opinionsConsent
    ? newsletterTokenList.cardTestsWithOpinions
    : newsletterTokenList.cardTestsWithoutOpinions
  return promiseWrapper<NewsletterResponse, NewsletterPayload>(
    `${USER_BASE_URL_WT}${NEWSLETTER_SUBSCRIBE_ENDPOINT}`,
    'POST',
    payload,
  )
}

export const signUpForCurrencyCommentsNewsletter = (payload: NewsletterPayload): Promise<NewsletterResponse> => {
  payload['list'] = newsletterTokenList.currencyComments
  return promiseWrapper<NewsletterResponse, object>(
    `${USER_BASE_URL_WT}${NEWSLETTER_SUBSCRIBE_ENDPOINT}`,
    'POST',
    payload,
  )
}
